import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'id',
  Pagination: {
    items_per_page: '/ halaman',
    jump_to: 'Menuju',
    jump_to_confirm: 'konfirmasi',
    page: '',
    prev_page: 'Halaman Sebelumnya',
    next_page: 'Halaman Berikutnya',
    prev_5: '5 Halaman Sebelumnya',
    next_5: '5 Halaman Berikutnya',
    prev_3: '3 Halaman Sebelumnya',
    next_3: '3 Halaman Berikutnya',
  },
  DatePicker: {
    lang: {
      placeholder: 'Pilih tanggal',
      rangePlaceholder: [
        'Mulai tanggal',
        'Tanggal akhir',
      ],
      locale: 'id_ID',
      today: 'Hari ini',
      now: 'Sekarang',
      backToToday: 'Kembali ke hari ini',
      ok: 'Baik',
      clear: 'Bersih',
      month: 'Bulan',
      year: 'Tahun',
      timeSelect: 'pilih waktu',
      dateSelect: 'pilih tanggal',
      weekSelect: 'Pilih satu minggu',
      monthSelect: 'Pilih satu bulan',
      yearSelect: 'Pilih satu tahun',
      decadeSelect: 'Pilih satu dekade',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Bulan sebelumnya (PageUp)',
      nextMonth: 'Bulan selanjutnya (PageDown)',
      previousYear: 'Tahun lalu (Control + kiri)',
      nextYear: 'Tahun selanjutnya (Kontrol + kanan)',
      previousDecade: 'Dekade terakhir',
      nextDecade: 'Dekade berikutnya',
      previousCentury: 'Abad terakhir',
      nextCentury: 'Abad berikutnya',
    },
    timePickerLocale: {
      placeholder: 'Pilih waktu',
    },
  },
  TimePicker: {
    placeholder: 'Pilih waktu',
  },
  Calendar: {
    lang: {
      placeholder: 'Pilih tanggal',
      rangePlaceholder: [
        'Mulai tanggal',
        'Tanggal akhir',
      ],
      locale: 'id_ID',
      today: 'Hari ini',
      now: 'Sekarang',
      backToToday: 'Kembali ke hari ini',
      ok: 'Baik',
      clear: 'Bersih',
      month: 'Bulan',
      year: 'Tahun',
      timeSelect: 'pilih waktu',
      dateSelect: 'pilih tanggal',
      weekSelect: 'Pilih satu minggu',
      monthSelect: 'Pilih satu bulan',
      yearSelect: 'Pilih satu tahun',
      decadeSelect: 'Pilih satu dekade',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Bulan sebelumnya (PageUp)',
      nextMonth: 'Bulan selanjutnya (PageDown)',
      previousYear: 'Tahun lalu (Control + kiri)',
      nextYear: 'Tahun selanjutnya (Kontrol + kanan)',
      previousDecade: 'Dekade terakhir',
      nextDecade: 'Dekade berikutnya',
      previousCentury: 'Abad terakhir',
      nextCentury: 'Abad berikutnya',
    },
    timePickerLocale: {
      placeholder: 'Pilih waktu',
    },
  },
  Table: {
    filterTitle: 'Saring',
    filterConfirm: 'OK',
    filterReset: 'Hapus',
    selectAll: 'Pilih semua di halaman ini',
    selectInvert: 'Balikkan pilihan di halaman ini',
    sortTitle: 'Urutkan',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Batal',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Batal',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Cari',
    itemUnit: 'item',
    itemsUnit: 'item',
  },
  Upload: {
    uploading: 'Mengunggah...',
    removeFile: 'Hapus file',
    uploadError: 'Kesalahan pengunggahan',
    previewFile: 'File pratinjau',
    downloadFile: 'Unduh berkas',
  },
  Empty: {
    description: 'Tidak ada data',
  },
};

export default localeValues;
